/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import PageType from 'linced-app/enums/page-type';
import PageAccessLevel from '@linc-technologies/linced-common/enums/page-access-level';

export default class PageList extends Component {
  Scopes = Scopes;
  PageType = PageType;
  PageAccessLevel = PageAccessLevel;
}
